import React, { Fragment } from 'react';

const CostLessThanInsuranceDeductible = ({ city = 'toronto' }) => (
  <Fragment>
    <p>
      In this case, the at-fault party will cover the cost of repair
      without opening an insurance claim. The maximum deductible is $2,500
      or $1,000 depending on your insurance coverage.
    </p>
    <br />
    <p>
      For only 60 cents extra per hour, you can choose Autzu’s reduced
      insurance deductible plan, lowering your deductible in case of an
      accident and minimizing your out-of-pocket expenses. This plan offers
      financial security and peace of mind while you're on the road.
    </p>
  </Fragment>
);

export default CostLessThanInsuranceDeductible;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/AccidentsAndInsurance/CostLessThanInsuranceDeductible.js